import React, {useState} from "react";
import {RSVPButton} from "./RSVP.jsx";
import Link from "@mui/material/Link";
import {
    Box,
    CardContent,
    Chip,
    Dialog,
    DialogTitle,
    IconButton,
    Typography,
    useMediaQuery,
    useTheme
} from "@mui/material";
import ReadMoreTwoToneIcon from '@mui/icons-material/ReadMoreTwoTone';
import Card from "@mui/material/Card";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import {display24HourTime} from "../shared/date.js";
import VisibilityButton from "./Button/VisibilityButton.jsx";
import {toSlots} from "../shared/class/event.ts";
import BookOnlineIcon from '@mui/icons-material/BookOnline';
import InstagramIcon from '@mui/icons-material/Instagram';
import TipBox from "./TipBox.jsx";
import EventPopular from "./Icon/EventPopular.jsx";

export const copyToClipboard = (e, input) => {
    e.preventDefault();
    navigator.clipboard.writeText(input);
}

export const Event = (props) => {
    const {venue, date, event_artists, event_instructors, title, ticketUrl, instagramUrl, special} = props.event;
    let [detailOpen, setDetailOpen] = useState(false);
    
  
    const slots = toSlots(event_artists, event_instructors)

    return  <div style={{paddingBottom: "20px"}} key={venue.venueKey}>
                {special && <Box style={{display: "flex", justifyContent: "center", backgroundColor: "red", padding: "5px", borderRadius: "5px", marginBottom: "10px"}}><Typography variant={"h6"} style={{color: "white"}}>Special Event</Typography></Box>}
                <div style={{float: "right"}}>
                    <RSVPButton
                        style={{marginTop: "3px"}}
                        date={date}
                        venueKey={venue.venueKey}
            
                       
                    />
                </div>
          
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                    <span style={{fontSize: "125%"}}>{venue.name}</span>
                    
                    <IconButton size={"small"} sx={{paddingTop: 0, marginTop: "0px"}} variant={"contained"} href={`/event/${venue.venueKey}/${date}`}><ReadMoreTwoToneIcon color={"primary"} /></IconButton>
                    <EventPopular event={props.event} />
                </div>
                <Box>
                        <Typography variant={"subtitle1"} style={{fontStyle: "italic"}}>{title || ""}</Typography>
                    </Box>
                    {ticketUrl && <Box>
                        <Button size={"small"} startIcon={<BookOnlineIcon />} href={ticketUrl} target={"_blank"}>Tickets</Button>
                    </Box>}
                    {instagramUrl && <Box>
                        <Button size={"small"} startIcon={<InstagramIcon />} href={instagramUrl} target={"_blank"}>Instagram</Button>
                    </Box>}
                <div>
                    {slots.map((slot, i) => <div key={i}>
                        <strong style={{paddingRight: "5px"}}>{display24HourTime(slot.time)}</strong>
                        {slot?.artist?.danceable ?
                            <strong><Link href={"/artist/" + slot?.artist?.artistKey}>{slot?.title}</Link></strong> : slot.title}
                            <VisibilityButton slot={slot}/>
                        {slot?.artist?.venmo && <TipBox artist={slot.artist} />}

                    </div>)}
                    {/* {myCreatedEventIds.hasOwnProperty(documentId) && <Button startIcon={<EditIcon />} size={"small"} href={"/event/edit/" + documentId}>Edit</Button>} */}
                </div>
                {detailOpen && <EventDetail {...props} setDetailOpen={setDetailOpen}/>}
            </div>
                
}


export const EventDetail = (props) => {
    // Accepts a single event object as described in the new format
    const {
        venue,
        date,
        event_artists = [],
        special = false,
        event_instructors = [],
        ticketUrl,
        instagramUrl,
        setDetailOpen
    } = props;

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Dialog open={true} fullScreen={fullScreen} fullWidth maxWidth={"md"}>
            <DialogTitle>
                <div style={{ float: "right" }}>
                    <Button color={"primary"} variant={"contained"} onClick={() => setDetailOpen(false)}>
                        <CloseIcon />
                    </Button>
                </div>
                <div>
                    <em>{venue?.name || venue?.venue || "Venue"}</em>
                </div>
            </DialogTitle>
            <Card>
                <CardContent>
                    {special && <div style={{display: "flex", justifyContent: "center", backgroundColor: "red", padding: "5px"}}>Special Event</div>}
                    <h5>Lineup for {date}</h5>
                    <div style={{ paddingBottom: "20px" }}>
                        <div>
                            {event_artists.map((ea, i) => (
                                <div key={i}>
                                    <strong style={{ paddingRight: "5px" }}>
                                        {display24HourTime(ea.time)}
                                    </strong>
                                    {ea.artist?.danceable ? (
                                        <strong>
                                            <Link href={"/artist/" + ea.artist.artistKey}>{ea.artist.name}</Link>
                                        </strong>
                                    ) : (
                                        ea.title
                                    )}
                                    {ea.artist?.tag && <span> <i>{ea.artist.tag}</i> </span>}
                                    {ea.artist?.venmo && (
                                        <Chip
                                            onClick={e => {
                                                e.preventDefault();
                                                if (props.user?.setTipBoxData) {
                                                    props.user.setTipBoxData({ band: ea.artist.name, url: ea.artist.venmo });
                                                }
                                            }}
                                            size={"small"}
                                            color={"info"}
                                            label={"tip"}
                                            component={"a"}
                                            clickable
                                        />
                                    )}
                                </div>
                            ))}
                        </div>
                        {event_instructors.length > 0 && (
                            <>
                                <h5>Instructors</h5>
                                <div>
                                    {event_instructors.map((ei, i) => (
                                        <div key={i}>
                                            <strong>{ei.instructor?.name || ei.title}</strong>
                                            {ei.instructor?.instagram && (
                                                <span> (<a href={`https://instagram.com/${ei.instructor.instagram}`} target="_blank" rel="noopener noreferrer">@{ei.instructor.instagram}</a>)</span>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </>
                        )}
                        <h5>Details</h5>
                        <div><small>Location: {venue?.location}</small></div>
                        <div><small>Cover: {venue?.cover}</small></div>
                        <div><small>Ages: {venue?.age}</small></div>
                        <div><small>Address: {venue?.address}, {venue?.city}, {venue?.state} {venue?.zip}</small></div>
                        {ticketUrl && <div><Link href={ticketUrl} target="_blank">Tickets</Link></div>}
                        {instagramUrl && <div><Link href={instagramUrl} target="_blank">Instagram</Link></div>}
                    </div>
                </CardContent>
            </Card>
        </Dialog>
    );
}

